import { createSlice } from "@reduxjs/toolkit";

import * as meetingService from "../service/meetingService";

export const statuses = {
  upcoming: "upcoming",
  past: "past",
};

export const criteria = {
  createdAt: "createdAt",
  updatedAt: "updatedAt",
};

export const sort = {
  summary: "summary",
  scheduledAt: "scheduledAt",
};

export const order = {
  asc: "asc",
  desc: "desc",
};

const initialState = {
  showFilter: false,
  status: statuses.upcoming,
  dateCriteria: criteria.createdAt,
  dateRange: undefined,
  sortBy: sort.scheduledAt,
  orderBy: order.desc,

  googleConnected: false,
  googleName: "",
  email: "",
  avatar: "",
};

const meetingSlice = createSlice({
  name: "meetings",
  initialState,
  reducers: {
    toggleFilter(state) {
      state.showFilter = !state.showFilter;
    },

    updateStatus(state, action) {
      state.status = action.payload;
    },

    updateDateCriteria(state, action) {
      state.dateCriteria = action.payload;
    },

    updateDateRange(state, action) {
      state.dateRange = action.payload;
    },

    updateSortBy(state, action) {
      state.sortBy = action.payload;
    },

    updateOrderBy(state, action) {
      state.orderBy = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(meetingService.connectGoogle.fulfilled, (state, action) => {
        state.googleConnected = action.payload.connected;
        state.googleName = action.payload.accountName || "";
        state.email = action.payload.email || "";
        state.avatar = action.payload.avatar || "";
      })

      .addCase(meetingService.disconnectGoogle.fulfilled, (state, action) => {
        state.googleConnected = action.payload.connected;
        state.googleName = "";
        state.email = "";
        state.avatar = "";
      });
  },
});

export const {
  toggleFilter,
  updateStatus,
  updateDateCriteria,
  updateDateRange,
  updateOrderBy,
  updateSortBy,
} = meetingSlice.actions;

export default meetingSlice.reducer;
